import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectGroupedInvoices: {
    invoieList: [],
    hasDisabledInvoice: false,
  },
};

const projectDetailsSlice = createSlice({
  name: 'projectDetails',
  initialState: initialState,
  reducers: {
    setProjectGroupedInvoices(state, { payload }) {
      state.projectGroupedInvoices = payload;
    },
  },
});

export const { setProjectGroupedInvoices } = projectDetailsSlice.actions;
export const projectDetailsReducer = projectDetailsSlice.reducer;
